import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledCarouselBullets = styled('div')<{ bulletCount: number }>`
  ${rtl`
    background-color: red;
    position: absolute;
    right: ${toRem(16)};
    bottom: ${toRem(24)};
    height: ${toRem(32)};
    min-width: ${(p: { bulletCount: number }) => {
      return p.bulletCount !== 5 ? toRem(10 + 10 + p.bulletCount * 16) : toRem(94);
    }};
    border-radius: 22px;
    background-color: ${theme.color['black']}54;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding-right: ${toRem(8)};
    padding-left: ${toRem(8)};
    .bullet {
      border-radius: 50%;
      background-color: ${theme.color['white']};
      height: ${toRem(6)};
      width: ${toRem(6)};
      opacity: 0.34;
      &.active {
        opacity: 1;
        height: ${toRem(8)};
        width: ${toRem(8)};
      }
    }
  `}
`;
